import { useMemo } from 'react'

import type { VaultCategory } from '@api'

import { classNames } from '@/utils/helpers.ts'

interface Props {
  medias?: VaultCategory['medias']
}

export function VaultCategoryMediasPreview({ medias }: Props) {
  const previewUrls = useMemo(() => medias?.map(({ url }) => url), [medias])

  return previewUrls?.map((url, i, self) => (
    <div
      key={url}
      style={{ zIndex: i + 1 }}
      className={classNames(
        'flex h-[32px] w-[32px] items-center justify-center overflow-hidden rounded-[6px] border border-white bg-white dark:bg-black',
        {
          'translate-x-1/3': i === 1 && self.length > 2,
          'translate-x-2/3': i === 0 && self.length > 1,
        },
      )}
    >
      <img
        className="h-[48px] w-[48px] rounded"
        src={url}
        alt=""
      />
    </div>
  ))
}
